export default "__VITE_ASSET__M9cOl_Ln__"